export const VERSION_ASIGNACION = "1.0.1";

export const ASIGNACION_FROM = {
    DIVIDIR: "DIVIDIR",
    UNIR: "UNIR",
    EXCEL: "EXCEL",
    DIVIDIR_PRODUCTOS: "DIVIDIR_PRODUCTOS",
    DIVIDIR_ENTREGAS: "DIVIDIR_ENTREGAS",
};